export function XeroSettingsCtrl (
  $q,
  $rootScope,
  $state,
  $scope,
  $translate,
  $window,
  accountingSettings,
  API,
  confirm,
  messages,
  paymentTypes,
  sessionObjAPI,
  settings,
  workshopAPI,
  xeroApi
) {
  $scope.isNewUser = settings.needs_xero_setup && xeroApi.isNewUser();
  $scope.loading   = true;
  $scope.loaded    = true;

  $scope.accountingSettings = accountingSettings;
  $scope.paymentTypes       = paymentTypes;

  $scope.initialize = function (settings, fromSave) {
    $scope.settings = settings;

    sessionObjAPI.refresh()
    .then(() => xeroApi.getSettings())
    .then(xero => {
      $scope.customXeroSalesTax = {
        tax_category: 'S'
      };
      $scope.customXeroPurchasesTax = {
        tax_category: 'P'
      };

      $scope.xeroSalesTaxRef     = [];
      $scope.xeroPurchasesTaxRef = [];

      $scope.business_id_name = sessionObjAPI.company().business_id_name;

      $scope.allAccounts     = xero.chart_of_accounts.all_accounts;
      $scope.expenseAccounts = xero.chart_of_accounts.expense_accounts;
      $scope.paymentAccounts = xero.chart_of_accounts.payment_accounts;
      $scope.revenueAccounts = xero.chart_of_accounts.revenue_accounts;
      $scope.tenants         = xero.tenants;

      $scope.xeroSalesTaxRates     = [];
      $scope.xeroPurchasesTaxRates = [];

      angular.forEach(xero.tax_rates, rate => {
        var obj = {};

        angular.extend(obj, rate);

        $scope.xeroSalesTaxRates.push(obj);

        var obj = {};

        angular.extend(obj, rate);

        $scope.xeroPurchasesTaxRates.push(obj);
      });

      $scope.xeroSalesTaxRates.push({
        custom        : true,
        effective_rate: '',
        name          : 'Create Custom',
        tax_category  : 'S',
        tax_type      : ''
      });

      $scope.xeroPurchasesTaxRates.push({
        custom        : true,
        effective_rate: '',
        name          : 'Create Custom',
        tax_category  : 'P',
        tax_type      : ''
      });

      angular.forEach($scope.xeroSalesTaxRates, tax => {
        var obj = {};

        angular.extend(obj, tax);

        $scope.xeroSalesTaxRef.push(obj);
      });

      angular.forEach($scope.xeroPurchasesTaxRates, tax => {
        var obj = {};

        angular.extend(obj, tax);

        $scope.xeroPurchasesTaxRef.push(obj);
      });

      // Loop through the tax rates to see if one matches the current taxt type.
      for (let i=0; i < $scope.xeroSalesTaxRates.length; i++) {

        if ($scope.xeroSalesTaxRates[i].tax_type == $scope.settings.xero_sales_tax_type) {
          $scope.settings.xeroSalesTax = $scope.xeroSalesTaxRates[i];
          break;
        }
      };

      // Loop through the tax rates to see if one matches the current tax type.
      for (let i=0; i < $scope.xeroPurchasesTaxRates.length; i++) {

        if ($scope.xeroPurchasesTaxRates[i].tax_type == $scope.settings.xero_purchases_tax_type) {
          $scope.settings.xeroPurchasesTax = $scope.xeroPurchasesTaxRates[i];
          break;
        }
      };

      $scope.loading = false;

      if (fromSave) {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

        $state.go('app.xero-settings', {
          new_user: null
        }, {
          inherit: false,
          reload : false
        });

        $scope.isNewUser = false;
        $scope.saving    = false;
      }
    })
    .then(() => xeroApi.getTrackingCategories())
    .then(trackingCategories => {
      $scope.trackingCategories = trackingCategories;

      return xeroApi.accounts();
    })
    .then(( accounts ) => {
      $scope.accounts = accounts.all_accounts;
    })
    .finally(() => {
      $scope.loading = false;
    });
  };

  $scope.authorize = function () {
    $q.when()
    .then(() => $rootScope.Company.confirmAccountingIntegration())
    .then(() => $rootScope.Company.isLinkedToBranch() && !$rootScope.Company.isSharedAccounting() ?
      $rootScope.Company.shareAccounting('xero')
      .catch(() => $q.when(true)) :
      $q.when(true)
    )
    .then(() => xeroApi.checkExistingIntegrations())
    .then(response => response === 'true' ?
      confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.CONFIRM_INTEGRATION', { name: 'Xero' }))
      .catch(() => confirm.textConfirm($translate.instant('JS_SPACE.INTEGRATIONS.CLEAR_ID_STATEMENT'), 'CLEAR IDS'))
      .then(() => xeroApi.clearID()) :
      $q.when(true)
    )
    .then(() => {
      if (sessionObjAPI.company().has_myob) {
        return $q.reject($translate.instant('JS_SPACE.INTEGRATIONS.ACCOUNTING_UNAUTH_FIRST', {
          name1: 'Xero',
          name2: 'MYOB'
        }));
      }
      else if ($rootScope.Company.hasIntegration('quickbooks')) {
        return $q.reject($translate.instant('JS_SPACE.INTEGRATIONS.ACCOUNTING_UNAUTH_FIRST', {
          name1: 'Xero',
          name2: $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE')
        }));
      }

      return $q.when(true);
    })
    .then(() => {
      $window.location.assign(`${API.url}/xero/new`);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.unauthorize = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISE', { name: 'Xero' }))
    .then(() => workshopAPI.get('/company/remove_xero'))
    .then(() => sessionObjAPI.refresh())
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.resetXeroSalesTaxes = function () {
    $scope.customXeroSalesTax = {
      tax_category: 'S'
    };

    $scope.settings.xero_sales_tax_type = $scope.settings.xeroSalesTax.tax_type;
    $scope.settings.sales_tax_rate      = $scope.settings.xeroSalesTax.effective_rate;
  };

  $scope.resetXeroPurchasesTaxes = function () {
    $scope.customXeroPurchasesTax = {
      tax_category: 'P'
    };

    $scope.settings.xero_purchases_tax_type = $scope.settings.xeroPurchasesTax.tax_type;
    $scope.settings.purchases_tax_rate      = $scope.settings.xeroPurchasesTax.effective_rate;
  };

  $scope.setPurchaseAccounts = function () {
    $scope.accountingSettings.xero_accessories_purchases_account = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.xero_vendor_invoice_account : '';
    $scope.accountingSettings.xero_consumable_purchases_account  = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.xero_vendor_invoice_account : '';
    $scope.accountingSettings.xero_labor_purchases_account       = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.xero_vendor_invoice_account : '';
    $scope.accountingSettings.xero_stock_purchases_account       = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.xero_vendor_invoice_account : '';
    $scope.accountingSettings.xero_sublet_purchases_account      = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.xero_vendor_invoice_account : '';
    $scope.accountingSettings.xero_tires_purchases_account       = $scope.accountingSettings.use_product_for_purchase_account ? $scope.settings.xero_vendor_invoice_account : '';
  };

  $scope.setTenant = function () {
    const id = $scope.settings.xero_tenant_id;
    const tenant = $scope.tenants.filter(tenant => tenant.tenant_id === id)[0];

    $scope.settings.xero_tenant_type = tenant.tenant_type;
  };

  $scope.setXeroSharesAccount = function () {
    xeroApi.shareAccount(settings.shares_accounting)
    .then(response => {
      if (response) {
        messages.show('Shares Accounting setting successfully changed');

        $state.reload();
      }
    })
    .catch(err => {
      messages.error(err);

      //reverts the toggle value to its original value before the call since it was returned as an error
      settings.shares_accounting = !settings.shares_accounting;
    });
  };

  $scope.save = {
    accountingSettings (form) {
      $rootScope.Company.saveAccountingSettings($scope.accountingSettings)
      .then(result => {
        $scope.initialize(result, true);
      })
      .catch(err => {
        messages.error(err);
      })
      .finally(() => {
        $scope.saving = false;
      });
    },
    settings: function (form) {
      workshopAPI.patch('/company', $scope.settings, 'company')
      .then(data => {
        $scope.initialize(data, true);
      })
      .catch(err => {
        $scope.saving = false;

        messages.error(err);
      });

    },
    xero: function (form) {
      $scope.saving = true;

      $q.when()
      .then(() => $rootScope.Company.saveAccountingSettings($scope.accountingSettings)).then(() => {
        if ($rootScope.Company.hasIntegration('xero') && ($scope.settings.xeroSalesTax || $scope.settings.xeroPurchasesTax) ) {
          if (!$scope.settings.xeroSalesTax.custom && !$scope.settings.xeroPurchasesTax.custom) {
            var salesTaxType     = $scope.settings.xeroSalesTax.tax_type;
            var matchingSalesTax = $scope.xeroSalesTaxRef.filter(tax => tax.tax_type === salesTaxType);

            var purchasesTaxType     = $scope.settings.xeroPurchasesTax.tax_type;
            var matchingPurchasesTax = $scope.xeroPurchasesTaxRef.filter(tax => tax.tax_type === purchasesTaxType);


            if ( (matchingSalesTax.length && parseFloat(matchingSalesTax[0].effective_rate) === parseFloat($scope.settings.xeroSalesTax.effective_rate)) &&
            ( matchingPurchasesTax.length && parseFloat(matchingPurchasesTax[0].effective_rate) === parseFloat($scope.settings.xeroPurchasesTax.effective_rate)) ) {
              $scope.save.settings();
              $scope.form.$setPristine();
            }
            else if ( (matchingSalesTax.length && parseFloat(matchingSalesTax[0].effective_rate) !== parseFloat($scope.settings.xeroSalesTax.effective_rate)) &&
            ( matchingPurchasesTax.length && parseFloat(matchingPurchasesTax[0].effective_rate) !== parseFloat($scope.settings.xeroPurchasesTax.effective_rate)) ) {
              $scope.settings.xeroSalesTax.tax_category     = 'S';
              $scope.settings.xeroPurchasesTax.tax_category = 'P';

              xeroApi.addXeroTax($scope.settings.xeroSalesTax)
              .then(data => {
                $scope.settings.sales_tax_rate      = data.effective_rate;
                $scope.settings.xero_sales_tax_type = data.tax_type;

                xeroApi.addXeroTax($scope.settings.xeroPurchasesTax)
                .then(data => {
                  $scope.settings.purchases_tax_rate      = data.effective_rate;
                  $scope.settings.xero_purchases_tax_type = data.tax_type;

                  $scope.save.settings();
                  $scope.form.$setPristine();
                })
                .catch(data => {
                  $scope.saving = false;

                  messages.show(data.message
                    ? data.message
                    : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
                });
              })
              .catch(data => {
                $scope.saving = false;

                messages.show(data.message
                  ? data.message
                  : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
              });
            }
            else if ( matchingSalesTax.length && parseFloat(matchingSalesTax[0].effective_rate) !== parseFloat($scope.settings.xeroSalesTax.effective_rate) ) {
              $scope.settings.xeroSalesTax.tax_category = 'S';

              xeroApi.addXeroTax($scope.settings.xeroSalesTax)
              .then(data => {
                $scope.settings.sales_tax_rate      = data.effective_rate;
                $scope.settings.xero_sales_tax_type = data.tax_type;

                $scope.save.settings();
                $scope.form.$setPristine();
              })
              .catch(data => {
                $scope.saving = false;

                messages.show(data.message
                  ? data.message
                  : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
              });
            }

            else if ( matchingPurchasesTax.length && parseFloat(matchingPurchasesTax[0].effective_rate) !== parseFloat($scope.settings.xeroPurchasesTax.effective_rate) ) {
              $scope.settings.xeroPurchasesTax.tax_category = 'P';

              xeroApi.addXeroTax($scope.settings.xeroPurchasesTax)
              .then(data => {
                $scope.settings.purchases_tax_rate      = data.effective_rate;
                $scope.settings.xero_purchases_tax_type = data.tax_type;

                $scope.save.settings();
                $scope.form.$setPristine();
              })
              .catch(data => {
                $scope.saving = false;

                messages.show(data.message
                  ? data.message
                  : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
              });
            }
          }
          else if ($scope.settings.xeroSalesTax.custom && $scope.settings.xeroPurchasesTax.custom) {
            xeroApi.addXeroTax($scope.customXeroSalesTax)
            .then(data => {
              $scope.settings.sales_tax_rate      = data.effective_rate;
              $scope.settings.xero_sales_tax_type = data.tax_type;

              xeroApi.addXeroTax($scope.customXeroPurchasesTax)
              .then(data => {
                $scope.settings.purchases_tax_rate      = data.effective_rate;
                $scope.settings.xero_purchases_tax_type = data.tax_type;

                $scope.save.settings();
                $scope.form.$setPristine();
              })
              .catch(data => {
                $scope.saving = false;

                messages.show(data.message
                  ? data.message
                  : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
              });
            })
            .catch(data => {
              $scope.saving = false;

              messages.show(data.message
                ? data.message
                : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
            });
          }
          else if ($scope.settings.xeroSalesTax.custom) {
            xeroApi.addXeroTax($scope.customXeroSalesTax)
            .then(data => {
              $scope.settings.sales_tax_rate      = data.effective_rate;
              $scope.settings.xero_sales_tax_type = data.tax_type;

              $scope.save.settings();
              $scope.form.$setPristine();
            })
            .catch(data => {
              $scope.saving = false;

              messages.show(data.message
                ? data.message
                : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
            });
          }
          else if ($scope.settings.xeroPurchasesTax.custom) {
            xeroApi.addXeroTax($scope.customXeroPurchasesTax)
            .then(data => {
              $scope.settings.purchases_tax_rate      = data.effective_rate;
              $scope.settings.xero_purchases_tax_type = data.tax_type;

              $scope.save.settings();
              $scope.form.$setPristine();
            })
            .catch(data => {
              $scope.saving = false;

              messages.show(data.message
                ? data.message
                : $translate.instant('JS_SPACE.XERO.UNKNOWN_ERROR_SAVING_XERO'), 'error');
            });
          }
        }
        else {
          $scope.save.settings();
          $scope.form.$setPristine();
        }
      });

    }
  };

  if ($rootScope.Company.hasIntegration('xero')) {
    $scope.initialize(settings);
  }
  else {
    $scope.loading  = false;
    $scope.settings = settings;
  }
}